// extracted by mini-css-extract-plugin
module.exports = {"admin":"_2UhZiqpGskAzobX_JnRDjK"};